import moment from "moment";

export const convertTimeFrom24To12 = (originalTime: string): string => {
  return moment(originalTime, "hh:mm").format("hh:mm a");
};

export const convertDate = (
  originalDate: string,
  originalFormat: string,
  formatDate: string
): string => {
  return moment(originalDate, originalFormat).format(formatDate);
};
